import { ErrorEvent } from '@sentry/browser';
import type { EventHint } from '@sentry/core/build/types/types-hoist/event';

import {
  buildRateLimitedSentryEvent,
  getRateLimitedSentryEventInfo,
  isIgnoredSentryError,
} from './sentryHandling';

export function beforeSend(event: ErrorEvent, hint: EventHint) {
  const error = hint.originalException as any;

  // Explicitly ignored errors
  if (error && error.message && error.message.match(/reading 'CodeMirror'/i)) {
    return null;
  }
  try {
    const rateLimitedEventInfo = getRateLimitedSentryEventInfo(event);
    if (rateLimitedEventInfo) {
      return buildRateLimitedSentryEvent(event, rateLimitedEventInfo);
    } else if (isIgnoredSentryError(event)) {
      return null;
    }
  } catch (e) {
    // @todo Catch the error.
  }
  return event;
}
